import { createMigration } from './utils';

/**
 * If an asset is in the scene level and `animateOutBehaviour` is `when_preceding` then the behaviour is changed to
 * `never`, unless one of the talking head designs, in which case the behaviour is 'always'.
 */
export const migrationTo9_159 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },

    migrateScene(scene) {
        return scene.withMutations(map => {
            const talkingHeadDesigns = [
                'talking_head_lowerThirds',
                'talking_head_callout',
                'talking_head_CurawayCallout',
                'talking_head_splitscreen_callout',
            ];

            if (talkingHeadDesigns.includes(scene.get('sceneDesign').split(':')[1])) {
                map.get('children', []).forEach((child, c) => {
                    const path = ['children', c];
                    map.setIn([...path, 'animateOutBehaviour'], 'always');
                });
            }
            else {
                map.get('children', []).forEach((child, c) => {
                    const path = ['children', c];
                    if (map.getIn([...path, 'animateOutBehaviour']) === 'when_preceding') {
                        map.setIn([...path, 'animateOutBehaviour'], 'never');
                    }
                });
            }
        });
    },
});

